export const formatDate = (date: Date) => {
  const months = (date.getMonth()+1) < 10 ? '0' + (date.getMonth()+1) : (date.getMonth()+1) + '';
  const days = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + '';
  const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() + '';
  const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() + '';
  const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() + '';
  const strTime = hours + ':' + minutes + ':' + seconds;
  return date.getFullYear() + "-" + months + "-" + days + " " + strTime;
}